<template>
  <div class="tw-flex tw-flex-col lg:tw-flex-row tw-min-h-screen">
    <div class="tw-flex-1 tw-overflow-hidden  tw-p-6 lg:tw-pr-0">
      <div class=" tw-bg-login-bg tw-relative tw-h-full tw-rounded-3xl">
        <div class="LoginMap tw-absolute tw-inset-0" />
        <div class="tw-relative tw-max-w-xl tw-flex tw-flex-col tw-justify-center tw-h-full tw-px-8 tw-pt-24 tw-pb-12 tw-mx-auto">
          <div class="tw-flex tw-gap-6 tw-items-center tw-mb-10">
            <div class="tw-w-[108px] tw-h-[108px]">
              <icon-logo-square />
            </div>
            <div>
              <h1 class="tw-tracking-wider tw-leading-9 tw-mb-2">
                {{ $t('main.login.welcome') }}
                <span
                  class="tw-text-primary"
                >i</span>Track
              </h1>
              <h3
                class="tw-text-primary tw-tracking-wide tw-leading-none"
              >
                {{ $t('main.login.subtitle') }}
              </h3>
            </div>
          </div>

          <div>
            <h3 class="tw-mb-2 tw-tracking-wide tw-leading-[24px]">
              {{ $t('main.login.q1') }}
            </h3>
            <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-mb-6 tw-leading-5 tw-tracking-normal">
              {{ $t('main.login.a1') }}
            </div>

            <h3 class="tw-mb-2 tw-tracking-wide tw-leading-[24px]">
              {{ $t('main.login.q2') }}
            </h3>
            <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-mb-10 tw-leading-5 tw-tracking-normal">
              {{ $t('main.login.a2') }}
            </div>

            <div class="tw-flex w-full tw-gap-4">
              <a
                class="tw-py-3 tw-pl-4 tw-pr-6 tw-rounded-2xl tw-border-2 tw-border-solid	tw-border-primary"
                :href="openAppLink(false)"
                target="_blank"
              >
                <span class="tw-flex tw-whitespace-nowrap tw-text-primary">
                  <icon-apple class="tw-mr-2" />
                  <span class="tw-flex tw-flex-col">
                    <span class="tw-text-xs tw-leading-[14px]">
                      Download on the
                    </span>
                    <span class="tw-font-bold tw-text-xl tw-leading-[24px]">
                      App Store
                    </span>
                  </span>
                </span>
              </a>
              <a
                class="tw-py-3 tw-pl-4 tw-pr-6 tw-rounded-2xl tw-border-2 tw-border-solid	tw-border-primary"
                :href="openAppLink(true)"
                target="_blank"
              >
                <span class="tw-flex tw-whitespace-nowrap tw-text-primary">
                  <icon-google-play class="tw-mr-2" />
                  <span class="tw-flex tw-flex-col">
                    <span class="tw-text-xs tw-leading-[14px]">
                      Get it on
                    </span>
                    <span class="tw-font-bold tw-text-xl tw-leading-[24px]">
                      Google Play
                    </span>
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-px-8 xl:tw-px-28 tw-bg-white tw-flex tw-flex-col tw-items-center tw-gap-10 tw-justify-between">
      <div class="tw-pt-[100px]">
        <br>
      </div>
      <div class="tw-max-w-full LoginFormContainer">
        <h2 class="tw-mb-4 tw-leading-7 tw-tracking-wide">
          {{ $t('common.fields.title') }}
        </h2>

        <el-form
          ref="Form"
          :model="form"
          :rules="formRules"
          label-position="top"
          :disabled="isLoading"
          autocomplete="off"
          hide-required-asterisk
          @submit.native.prevent="submitForm"
        >
          <i-form-item
            :label="$t('common.fields.login')"
            prop="username"
            class="tw-mb-4"
          >
            <el-input
              v-model="form.username"
              autofocus
              autocomplete="off"
            />
          </i-form-item>
          <i-form-item
            :label="$t('common.fields.password')"
            prop="password"
            class="tw-mb-4"
          >
            <PasswordInput v-model="form.password" />
          </i-form-item>
          <div class="tw-flex tw-gap-3">
            <i-button
              size="large"
              class="tw-px-8"
              @click="resetPasswordDialogIsOpen=true"
            >
              {{ $t('main.login.forgot_pass') }}
            </i-button>
            <i-button
              type="primary"
              size="large"
              class="tw-flex-1"
              native-type="submit"
            >
              <icon-user-arrow-left />
              {{ $t('common.actions.login') }}
            </i-button>
          </div>
        </el-form>
      </div>
      <div class="tw-text-base tw-text-gray-dark dark:tw-text-dm-gray-dark tw-pb-[100px] tw-tracking-normal">
        {{ $t('main.login.contact') }} <a href="mailto:help@app.itrack.cz">help@app.itrack.cz</a>
      </div>
    </div>
    <ResetPasswordDialog
      :is-open="resetPasswordDialogIsOpen"
      @close="resetPasswordDialogIsOpen = false"
    />
  </div>
</template>

<script>
import isMobile from 'ismobilejs';
import _get from 'lodash/get';
import { mapState } from 'vuex';
import ResetPasswordDialog from '@/components/Dialogs/ResetPasswordDialog.vue';
import PasswordInput from '@/components/shared/PasswordInput.vue';

export default {
  components: {
    PasswordInput,
    ResetPasswordDialog,
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      formRules: {
        username: [
          { required: true, message: this.$t('common.fields.required') },
        ],
        password: [
          { required: true, message: this.$t('common.fields.required') },
        ],
      },
      isLoading: false,
      recaptchaRequired: false,
      resetPasswordDialogIsOpen: false,

      BASE_HOST: import.meta.env.VITE_HOSTURL,
    };
  },

  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      interfaceLanguages: (state) => state.v2.shared.enums.interface_languages,
    }),
  },

  mounted() {
    if (!this.$route.query.noMobileRedirect && (isMobile().apple.device || isMobile().android.device)) {
      this.$router.push('/mobile');
    }
  },

  methods: {
    async submitForm() {
      let token = undefined;
      if (this.recaptchaRequired){
        await this.$recaptchaLoaded();
        token = await this.$recaptcha('login');
      }

      this.isLoading = true;
      this.$store
        .dispatch('auth/login', {
          username: this.form.username,
          password: this.form.password,
          g_recaptcha_response: token,
        })
        .then(() => {
          this.isLoading = false;
          this.loginSuccessful();
        })
        .catch((error) => {
          this.isLoading = false;

          const message = _get(error, 'response.data.message');
          this.$message.error({
            message: this.$capitalize(message || this.$t('core.error.internal_server_error')),
            showClose: true,
            offset: this.$getMessageOffsetFromTop(),
          });

          if (error && error.data && error.data.recaptcha_requested) {
            this.recaptchaRequired = true;
          }
        });
    },

    async loginSuccessful() {
      await Promise.all([
        this.$store.dispatch('v2/shared/enums/loadInternalUserRoles'),
        this.$store.dispatch('v2/shared/enums/loadClientUserRoles'),
        this.$store.dispatch('v2/shared/profile/loadMe'),
        this.$store.dispatch('v2/shared/enums/loadInterfaceLanguages'),
      ]);

      const f = localStorage.getItem(
        'itrack_adm_forward_to_foreigner',
      );
      const ff = localStorage.getItem(
        'itrack_adm_forward_to_foreigner_messaging',
      );
      const fff = localStorage.getItem(
        'itrack_adm_forward_to_foreigner_questionnaires',
      );
      const ffff = localStorage.getItem('itrack_forward_to_me');

      if (f != null) {
        localStorage.removeItem('itrack_adm_forward_to_foreigner');
        if (
          this.me.role !== this.$roles.FOREIGNER &&
                  this.me.role !== this.$roles.FAMILY
        )
          location.replace('/foreigners/' + f);
        else {
          location.replace('/');
        }
      } else if (ff != null) {
        localStorage.removeItem(
          'itrack_adm_forward_to_foreigner_messaging',
        );
        if (
          this.me.role !== this.$roles.FOREIGNER &&
                  this.me.role !== this.$roles.FAMILY
        )
          location.replace('/foreigners/' + ff + '/messaging');
        else {
          location.replace('/');
        }
      } else if (fff != null) {
        localStorage.removeItem(
          'itrack_adm_forward_to_foreigner_questionnaires',
        );
        if (
          this.me.role !== this.$roles.FOREIGNER &&
                  this.me.role !== this.$roles.FAMILY
        )
          location.replace(
            '/foreigners/' + fff + '/questionnaires',
          );
        else {
          location.replace('/');
        }
      } else if (ffff != null) {
        localStorage.removeItem('itrack_forward_to_me');
        location.replace('/me');
      } else {
        location.replace('/');
      }

      this.$store.dispatch('coreData/verifyLocalStorageRedirectIsChecked');
    },

    openAppLink(isAndroid) {
      return isAndroid ? import.meta.env.VITE_GOOGLE_PLAY_LINK : import.meta.env.VITE_APP_STORE_LINK;
    },
  },
};
</script>

<style scoped>
.LoginFormContainer {
  width: 400px;
}
.LoginMap {
  background-image: url("../assets/world-map.webp");
  background-size: auto 100%; /* Keeps height 100% and scales width proportionally */
  background-position: left center; /* Centers the image horizontally and vertically */
  background-repeat: no-repeat; /* Ensures no image repetition */
}
</style>
